<template>
  <div v-loading="isLoading">
    <button @click="handleAddEventIdFromLamps()"
            class="btn btn-success btn-fill btn-wd">
      Adicionar o EventId nas trocas de lâmpadas
    </button>
    <el-progress :percentage="progressPercentage"></el-progress>
  </div>
</template>
<script>
  import Couchdb from 'src/services/Couchdb'
  import swal from 'sweetalert2'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    data () {
      return {
        eventIdSelected: '',
        isLoading: false,
        progress: 0,
        total: 0
      }
    },
    computed: {
      ...mapGetters('events', {
        events: 'events'
      }),

      progressPercentage () {
        if (this.total === 0) {
          return 0
        }
        return parseInt((this.progress / this.total) * 100)
      }
    },
    methods: {
      ...mapActions('events', {
        fetchEvents: 'fetchAll'
      }),
      handleAddEventIdFromLamps () {
        this.isLoading = true
        this.total = 0
        Couchdb.collection('lamps')
          .where('eventId', {'$or': [{'$exists': false}, {'$eq': null}]})
          .get()
          .then(docs => {
            this.isLoading = false
            this.progress = 0
            this.total = docs.length
            let swalOptions = {
              title: `Existem ${this.total} lâmpadas.`
            }
            if (this.total === 0) {
              swal({
                title: swalOptions.title,
                text: `Todas as lâmpadas possui evento.`,
                type: 'error',
                confirmButtonClass: 'btn btn-info btn-fill',
                buttonsStyling: false
              })
            } else {
              swal({
                title: swalOptions.title,
                html: `Você quer setar o evento em todos as lâmpadas?`,
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Sim, faça isso!',
                cancelButtonText: 'Não',
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                buttonsStyling: false
              })
                .then(async () => {
                  for (const lamp of docs) {
                    await this.exec(lamp)
                      .then(result => {
                        if (this.progress === this.total) {
                          this.notifyFinish()
                        }
                      })
                      .catch(err => {
                        console.log(err)
                        swal({
                          width: 1000,
                          title: 'Ocorreu um erro ao executar essa ação.',
                          text: JSON.stringify(err),
                          type: 'error',
                          confirmButtonClass: 'btn btn-danger btn-fill',
                          buttonsStyling: false
                        })
                      })
                  }
                })
            }
          })
          .catch(err => {
            console.log(err)
            this.isLoading = false
          })
      },
      async exec (lamp) {
        for (let event of this.events) {
          if (event.startDate <= lamp.createdAt && lamp.createdAt <= event.dateTimeCeremony) {
            lamp.eventId = event._id
            break
          } else {
            lamp.eventId = null
          }
        }
        let update = await Couchdb.update(lamp._id, lamp)
        this.progress = this.progress + 1
        return update
      },
      notifyFinish () {
        swal({
          title: 'Sucesso',
          text: `Ação executada com sucesso.`,
          type: 'success',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/commands/SetEventidLamps.vue